import { useState } from "react";
import LegalDocumentLayout from "./LegalDocumentLayout";
import { LEGAL_LANGUAGE_DA, getCookieDocument, getLegalUiText } from "./legalDocuments";

export default function CookiePolicyView() {
  const [language, setLanguage] = useState(LEGAL_LANGUAGE_DA);
  const document = getCookieDocument(language);

  return (
    <LegalDocumentLayout
      title={document.title}
      lastUpdated={document.lastUpdated}
      intro={document.intro}
      language={language}
      onLanguageChange={setLanguage}
      translationNotice={getLegalUiText(language).translationNotice}
    >
      {document.content}
    </LegalDocumentLayout>
  );
}